import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Box, Center, Heading, Spinner, Text } from '@chakra-ui/react';
import { CommentCard } from '@src/components/sco/Comments/CommentCard';
import { gql } from '@src/lib/gql';
type Props = {
  commentId: string;
};
export const CommentSingle = props => {
  const $ = _c(16);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = CommentSingle.queries.comment();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.commentId) {
    t1 = {
      variables: {
        commentId: props.commentId
      }
    };
    $[1] = props.commentId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const query = useQuery(t0, t1);
  const comment = query.data?.forum?.comment;
  if (query.loading) {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Center><Spinner /></Center>;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  if (query.error) {
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Center><Heading>Error loading comment.</Heading></Center>;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  if (!comment) {
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Center><Heading>Comment not found.</Heading></Center>;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  let t2;
  if ($[6] !== comment) {
    t2 = <CommentCard key={comment.commentId} comment={comment} />;
    $[6] = comment;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = comment.thread?.attachment?.title || "N/A";
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <br />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = comment.thread?.attachmentType;
  const t6 = comment.thread?.attachmentId;
  let t7;
  if ($[9] !== t3 || $[10] !== t5 || $[11] !== t6) {
    t7 = <Box padding="1em" textAlign="center"><Text fontSize="sm" opacity={0.5}>{"Subject: "}{t3}{t4}{"Attachment: "}{t5}{" #"}{t6}</Text></Box>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t2 || $[14] !== t7) {
    t8 = <Box>{t2}{t7}</Box>;
    $[13] = t2;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
CommentSingle.queries = {
  comment: () => gql`
    query(
      $commentId: String!
    ) {
      forum {
        id
        comment(
          commentId: $commentId
        ) {
          id
          ${CommentCard.fragments.ScoComment()}
          thread {
            id
            attachmentType
            attachmentId
            attachment {
              id
              title
            }
          }
        }
      }
    }
  `
};
CommentSingle.fragments = {};